import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const ListBullets: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m660 240h-390v-30h360c16.57 0 30 13.43 30 30z' />
    <circle cx='165' cy='225' r='45' />
    <path d='m660 570h-390v-30h360c16.57 0 30 13.43 30 30z' />
    <circle cx='165' cy='555' r='45' />
    <path d='m660 405.85h-390v-30h360c16.57 0 30 13.43 30 30z' />
    <circle cx='165' cy='390.85' r='45' />
  </IconBase>
));

ListBullets.displayName = 'ListBullets';

export default ListBullets;
